import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getIcon } from '../../util/icons';

class ConfirmModal extends Component{

  componentWillMount(){
    this.hide = this.hide.bind(this);
    this.confirm = this.confirm.bind(this);
    this.secondaryAction = this.secondaryAction.bind(this);
  }

  hide(){
    if(!this.props.confirming){
      this.props.hide();
    }
  }
  confirm(){
    if(!this.props.confirming){
      this.props.onConfirm();
    }
  }
  secondaryAction(){
    if(!this.props.confirming){
      this.props.onSecondaryAction();
    }
  }

  getConfirmButtonText(){

    const { confirming, confirmText, confirmingText } = this.props;

    if(confirming){
      if(confirmingText){
        return confirmingText;
      }
      else if(confirmText){
        return confirmText || 'OK';
      }
    }
    else{
      return confirmText || 'OK';
    }
  }

  render(){

    if(!this.props.visible){
      return null;
    }

    const { message, messageHtml, confirming, confirmText, cancelText, iconKey, secondaryActionText, buttonClass, hideCancel } = this.props;

    return (
      <div className="modal">
        <div className="modal-container">
          <div className="close-icon" onClick={this.hide}>X</div>
          <div className="modal-content">
            <div className="message-icon">{getIcon(iconKey || 'info')}</div>
            {message &&
              <div className="message">
                <p>{message}</p>
              </div>
            }
            {messageHtml &&
              <div className="message" dangerouslySetInnerHTML={{__html: messageHtml}}></div>
            }
          </div>
          <div className="modal-actions">
            <button disabled={confirming} onClick={this.confirm} className={`button ${buttonClass ? buttonClass : 'primary'}`}>{this.getConfirmButtonText()}</button>
            {secondaryActionText &&
              <button disabled={confirming} onClick={this.secondaryAction} className="button grey-button">{secondaryActionText}</button>
            }
            {!hideCancel &&
              <button disabled={confirming} onClick={this.hide} className="button grey-outline">{cancelText ? cancelText : 'Cancel'}</button>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default ConfirmModal;



// WEBPACK FOOTER //
// ./src/components/modals/confirm.js